<script>
  import { onMount, tick } from "svelte";
  import { useNavigate } from "svelte-navigator";
  import { filtersConfigStore } from "@stores/damFiltersConfigStores.js";
  import { getApplicableFilters } from "@utils/getDamApplicableFilters.js";
  import { ROUTES } from "@utils/routes.js";
  // ui-elements
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";
  import PaxbotChat from "lib/components/paxbot/PaxbotChat.svelte";
  import ZoomableTreemap from "lib/components/zoomableTreemap/ZoomableTreemap.svelte";
  import Filter from "./components/filter/Filter.svelte";
  import AppDrilldownSourceMenu from "./components/AppDrilldownSourceMenu.svelte";
  import { uiFeatureStore } from "@stores/uiFeatureStore.js";

  // sidenav

  import {
    Accordion,
    SectionWrapper,
    Tooltip,
    Button,
  } from "paxray-components-svelte";
  import AppSelection from "./components/appSelection.svelte";
  import AppInformation from "./components/appInformation.svelte";
  import Header from "lib/components/Header.svelte";
  import * as yootils from "yootils";
  import { damfilters } from "lib/stores.js";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import Toggle from "lib/components/Toggle.svelte";
  import {
  BOT_WHITE_ICON,
    CATEGORY_ICON,
    FULLSCREEN_ICON,
    FULLSCREEN_OFF_ICON,
  } from "@utils/icons.js";

  export let idproject;

  const navigate = useNavigate();
  const { setCurrentView } = filtersConfigStore;

  let currentApp = [""];
  let selectedApp = "";
  let applicationKpisLoading = false;
  let windowPartitionsLoading = false;
  let loading = true;
  let optionTabs = ["Time", "Interactions"];
  let applicationlist = [];
  let windowlist = [];
  let currentWindowList = [];

  let fullscreen = false;
  let disabledlevels = [1, 2];
  let selectedLevel = 0;
  let partitionlabel = 0;

  let percentage = 1;

  let selectedKPIindex = 0;
  let selectedSourceIndex = 0;
  let treeData = {};
  let selectedLevelOptions = ["Applications", "Windows"];
  const genericPaxbotStarterQuestions = [
    "What should I look at first?",
    "Explain this view.",
  ];
  $: paxbotStarterQuestions = [
    ...genericPaxbotStarterQuestions,
    selectedKPIindex === 0
      ? "Where is the most time spent?"
      : "Where do most interactions happen?",
  ];

  let showAppTypes = true;
  let appTypesByName = {};
  let appInfoByName = {};
  let windowInfoByName = {};
  let appNameMappings = [];
  let minimumShareOptions = [0.5, 1, 2, 5, 10, 20];
  const appTypeDefinitions = [
    { key: "main", label: "Main Apps", color: "#b7e3bd" },
    { key: "support", label: "Support Apps", color: "#e5e8a8" },
    { key: "communication", label: "Communication Apps", color: "#abcfe8" },
    { key: "unwanted", label: "Unwanted Apps", color: "#e6a7ad" },
  ];
  let appTypeTotals = {};

  let zoomableTreemap;
  let paxbotOpen = false;
  let lastLoadKey = "";
  let partitionsRequestId = 0;
  let partitionsRequestController;
  let treeRequestId = 0;
  let treeRequestController;

  $: if (!minimumShareOptions.includes(Number(percentage))) percentage = 1;

  $: if (
    $damfilters &&
    ($filtersConfigStore.storeLoaded ||
      !($damfilters[idproject] || []).length) &&
    selectedSourceIndex !== null &&
    selectedSourceIndex !== undefined &&
    selectedKPIindex !== null &&
    selectedKPIindex !== undefined
  ) {
    if (selectedSourceIndex === 1 && selectedKPIindex === 1) {
      selectedKPIindex = 0;
    } else {
      selectedLevelOptions = ["Applications", "Windows"];

      const applicableFilters = getCurrentFilters();
      const loadKey = JSON.stringify({
        idproject,
        selectedKPIindex,
        selectedSourceIndex,
        percentage,
        filters: applicableFilters,
      });
      if (loadKey !== lastLoadKey) {
        lastLoadKey = loadKey;
        loadTree(applicableFilters);
        getWindowPartitions(applicableFilters);
      }
    }
  }

  // $: getWindowPartitions();

  $: {
    if (selectedKPIindex !== null) {
      currentApp = ["Applications"];
      selectedLevel = 0;
      setDisabledLevels();
      getCurrentAplicationlist();
    }
  }

  $: {
    if (selectedLevel >= 0) setDisabledLevels();
  }

  $: {
    if (!selectedApp) {
      downLevel();
    }
  }

  $: if (currentApp[0]) {
    updateAppSelection();
  }

  $: {
    if (!isNaN(selectedApp)) {
      getCurrentWindow();
    } else {
      currentApp[0] = selectedApp;
    }
  }

  $: {
    treeData;
    getCurrentAplicationlist();
  }

  $: {
    windowlist;
    treeData;
    if (currentApp[0]) getCurrentWindowsList();
  }

  $: currentAppData =
    selectedLevel === 0 || selectedLevel === 1
      ? applicationlist
      : currentWindowList;
  $: selectedApplicationKpi = applicationlist.find(
    (app) => app.id === currentApp[0] || app.id === selectedApp,
  );
  $: appSelectionKpiData =
    selectedLevel === 1
      ? selectedApplicationKpi
        ? [selectedApplicationKpi]
        : currentWindowList
      : null;

  $: buildAppTypeMapping(appNameMappings, applicationlist);
  $: appInfoByName = buildAppInfoMapping(applicationlist, treeData);
  $: windowInfoByName = buildWindowInfoMapping(windowlist, treeData);
  $: appTypeLegend = appTypeDefinitions.map((item) => ({
    ...item,
    value: appTypeTotals[item.key] || 0,
  }));
  $: untypedAppsPercentage = appTypeTotals.untyped || 0;
  $: noDataForFilters = !loading && !(treeData?.children?.length > 0);

  // Plattform-Feature "Main: Window Titles & UI Elements": ist es aus, bleibt
  // die Hauptphase auf der Anwendungsebene - kein Aufklappen zu Fenstertiteln
  // oder Bedienelementen (Datenschutz im Alltagsstrom).
  $: windowTitlesLocked =
    selectedSourceIndex === 1 &&
    !$uiFeatureStore.platformFeatures.mainWindowTitles;
  $: if (windowTitlesLocked && selectedLevel > 0) {
    selectedLevel = 0;
    currentApp = ["Applications"];
    selectedApp = "";
    setDisabledLevels();
  }

  // Plattform-Feature "Registrations: UI Elements": ist es aus, bleiben die
  // Registrierungen bei den Fenstertiteln - die Ebene der Bedienelemente ist gesperrt.
  $: elementsLocked =
    selectedSourceIndex === 0 &&
    !$uiFeatureStore.platformFeatures.registrationUiElements;
  $: if (elementsLocked && selectedLevel === 2) {
    selectedLevel = 1;
    setDisabledLevels();
  }

  function setDisabledLevels() {
    if (selectedLevel === 0) {
      disabledlevels = [1, 2];
    } else if (selectedLevel === 1) {
      disabledlevels = [2];
    } else {
      disabledlevels = [];
    }
  }

  async function loadTree(applicableFilters = getCurrentFilters()) {
    setCurrentView("App Drilldown", optionTabs[selectedKPIindex]);
    await tick();
    getTree(applicableFilters);
  }

  function getTree(applicableFilters = getCurrentFilters()) {
    treeRequestController?.abort();
    treeRequestController = new AbortController();
    const requestId = ++treeRequestId;

    if (selectedKPIindex === 0) {
      getTreeTime(applicableFilters, requestId, treeRequestController.signal);
    } else {
      getTreeInteractions(
        applicableFilters,
        requestId,
        treeRequestController.signal,
      );
    }
  }

  function dataSource() {
    return selectedSourceIndex === 1 ? "main" : "recordings";
  }

  function getCurrentFilters() {
    try {
      return getApplicableFilters($damfilters[idproject]);
    } catch (error) {
      return [];
    }
  }

  function normalizeAppName(name) {
    return `${name || ""}`.trim().toLowerCase();
  }

  function normalizeAppType(type) {
    const normalizedType = `${type || ""}`.trim().toLowerCase();
    return normalizedType === "supportive" ? "support" : normalizedType;
  }

  function isKnownAppType(type) {
    return appTypeDefinitions.some((definition) => definition.key === type);
  }

  function addAppTypeKey(target, name, type) {
    const key = normalizeAppName(name);
    if (key) target[key] = type;
  }

  function getAppTypeCandidates(item) {
    return [
      item.id,
      item.applicationname,
      item.appname,
      item.name,
      item.clearname,
      item.windowtitle,
    ];
  }

  function getDirectAppType(item) {
    return [
      item.apptype,
      item.appType,
      item.app_type,
      item.type,
      item.relevance,
    ]
      .map(normalizeAppType)
      .find(isKnownAppType);
  }

  function formatTreemapTime(seconds) {
    const totalMinutes = Math.floor(Number(seconds || 0) / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours === 0) return `${minutes}m`;
    return `${hours}h ${minutes}m`;
  }

  function openAppnameMapping() {
    navigate(`${ROUTES.dam.appnamemapping}?idproject=${idproject}`);
  }

  function buildAppTypeMapping(mappings, apps = []) {
    const nextAppTypesByName = {};
    mappings.forEach((mapping) => {
      const type = normalizeAppType(mapping.apptype);
      if (!isKnownAppType(type)) return;
      getAppTypeCandidates(mapping).forEach((name) => {
        addAppTypeKey(nextAppTypesByName, name, type);
      });
    });

    apps.forEach((app) => {
      const type =
        getDirectAppType(app) ||
        getAppTypeCandidates(app)
          .map((name) => nextAppTypesByName[normalizeAppName(name)])
          .map(normalizeAppType)
          .find(isKnownAppType);
      if (!type) return;
      getAppTypeCandidates(app).forEach((name) => {
        addAppTypeKey(nextAppTypesByName, name, type);
      });
    });

    appTypesByName = nextAppTypesByName;
  }

  function sumKpiRows(rows, values = {}) {
    return rows.reduce(
      (result, row) => ({
        ...result,
        time: result.time + (Number(row.time) || 0),
        mouseclicks: result.mouseclicks + (Number(row.mouseclicks) || 0),
        text_time: result.text_time + (Number(row.text_time) || 0),
        copy_time: result.copy_time + (Number(row.copy_time) || 0),
      }),
      { time: 0, mouseclicks: 0, text_time: 0, copy_time: 0, ...values },
    );
  }

  function buildAppInfoMapping(apps = [], tree = {}) {
    const nextAppInfoByName = {};
    apps.forEach((app) => {
      getAppTypeCandidates(app).forEach((name) => {
        const key = normalizeAppName(name);
        if (key) nextAppInfoByName[key] = app;
      });
    });
    const visibleApps = new Set(
      (tree.children || [])
        .filter((item) => normalizeAppName(item.name) !== "others")
        .map((item) => normalizeAppName(item.name)),
    );
    const otherApps = apps.filter(
      (app) => !visibleApps.has(normalizeAppName(app.clearname || app.id)),
    );
    if (otherApps.length) {
      nextAppInfoByName.others = sumKpiRows(otherApps, { clearname: "Others" });
    }
    return nextAppInfoByName;
  }

  function windowInfoKey(appName, windowTitle) {
    return `${normalizeAppName(appName)}\x1f${normalizeAppName(windowTitle)}`;
  }

  function buildWindowInfoMapping(windows = [], tree = {}) {
    const nextWindowInfoByName = {};
    const visibleApps = new Set(
      (tree.children || [])
        .filter((item) => normalizeAppName(item.name) !== "others")
        .map((item) => normalizeAppName(item.name)),
    );
    (tree.children || []).forEach((appNode) => {
      const isOtherApps = normalizeAppName(appNode.name) === "others";
      const appWindows = windows.filter((item) =>
        isOtherApps
          ? !visibleApps.has(normalizeAppName(item.clearname))
          : normalizeAppName(item.clearname) === normalizeAppName(appNode.name),
      );
      const visibleWindows = new Set(
        (appNode.children || [])
          .filter((item) => normalizeAppName(item.name) !== "others")
          .map((item) => normalizeAppName(item.name)),
      );
      (appNode.children || []).forEach((windowNode) => {
        const isOtherWindows = normalizeAppName(windowNode.name) === "others";
        const matchingWindows = appWindows.filter((item) =>
          isOtherWindows
            ? !visibleWindows.has(normalizeAppName(item.windowtitle))
            : normalizeAppName(item.windowtitle) ===
              normalizeAppName(windowNode.name),
        );
        if (!matchingWindows.length) return;
        nextWindowInfoByName[windowInfoKey(appNode.name, windowNode.name)] =
          matchingWindows.length === 1
            ? matchingWindows[0]
            : sumKpiRows(matchingWindows, {
                clearname: appNode.name,
                windowtitle: windowNode.name,
              });
      });
    });
    return nextWindowInfoByName;
  }

  function loadAppnameMapping() {
    fetchWithSession(`/api/damprojects/getAppnameMapping`)
      .then((res) => res.json())
      .then((data) => {
        appNameMappings = data || [];
      });
  }

  function downLevel() {
    if (selectedLevel > 0) {
      selectedLevel = selectedLevel - 1;
    }
    setDisabledLevels();
  }

  function updateAppSelection() {
    if (currentApp[0] !== selectedApp) {
      if (selectedLevel === 2) {
        if (windowlist.find((app) => app.windowtitle === currentApp[0])) {
          selectedApp = windowlist.find(
            (app) => app.windowtitle === currentApp[0],
          ).id;
        }
      } else {
        selectedApp = currentApp[0];
      }
    }
  }

  function getCurrentWindow() {
    if (selectedApp) {
      currentApp[0] = windowlist.find(
        (app) => app.id === selectedApp,
      ).windowtitle;
      levelUp();
    }
  }

  function levelUp() {
    if (windowTitlesLocked) return;
    if (elementsLocked && selectedLevel === 1) return;
    if (selectedLevel < 2) {
      selectedLevel = selectedLevel + 1;
    }
    setDisabledLevels();
  }

  function getCurrentWindowsList() {
    if (selectedLevel < 1) {
      currentWindowList = [];
    }
    if (
      windowlist.filter((app) => app.clearname === currentApp[0]).length > 0
    ) {
      currentWindowList = windowlist.filter(
        (app) => app.clearname === currentApp[0],
      );
      if (
        currentApp[0] !== "Aplications" &&
        treeData.children.find((data) => data.name === currentApp[0])
      ) {
        currentWindowList.forEach((app) => {
          app.disable = !treeData.children
            .filter((data) => data.name === currentApp[0])[0]
            .children.find((data) => data.name === app.windowtitle);
        });
      }
    }
  }

  function getCurrentAplicationlist() {
    applicationlist.forEach((app) => {
      app.disable = !treeData.children.find((data) => data.name === app.id);
    });
  }

  function getWindowPartitions(applicableFilters = getCurrentFilters()) {
    partitionsRequestController?.abort();
    partitionsRequestController = new AbortController();
    const requestId = ++partitionsRequestId;
    const { signal } = partitionsRequestController;
    applicationKpisLoading = true;
    windowPartitionsLoading = true;
    applicationlist = [];
    windowlist = [];
    currentWindowList = [];
    const filterString = JSON.stringify(applicableFilters);
    const source = dataSource();
    const applicationUrl = `/api/damprojects/getApplicationKPIs?project_id=${idproject}&filter=${filterString}&source=${source}`;
    const windowUrl = `/api/damprojects/getWindowTitleKPIs?project_id=${idproject}&filter=${filterString}&source=${source}`;

    loadKpiData(applicationUrl, requestId, signal, (applications) => {
      applicationlist = applications;
      applicationKpisLoading = false;
    }).catch(() => {
      if (requestId === partitionsRequestId) applicationKpisLoading = false;
    });
    loadKpiData(windowUrl, requestId, signal, (windows) => {
      windowlist = windows;
      windowPartitionsLoading = false;
    }).catch(() => {
      if (requestId === partitionsRequestId) windowPartitionsLoading = false;
    });
  }

  async function loadKpiData(url, requestId, signal, updateData) {
    const response = await fetchWithSession(url, { signal });
    const data = await response.json();
    if (requestId !== partitionsRequestId) return;
    updateData(data);

    if (data.some((row) => row?._details_pending)) {
      const detailResponse = await fetchWithSession(`${url}&details=true`, {
        signal,
      });
      const detailData = await detailResponse.json();
      if (requestId === partitionsRequestId) updateData(detailData);
    }
  }

  // AppScoresTreeTime will be use for time tab

  function getTreeInteractions(applicableFilters, requestId, signal) {
    loading = true;
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/damprojects/AppScoresTreeInteractions?project_id=${idproject}&filter=${filterString}&cutoffpercentage=${percentage / 100}&source=${dataSource()}`,
      { signal },
    )
      .then((res) => res.json())
      .then((data) => {
        if (requestId !== treeRequestId) return;
        treeData = data;
        loading = false;
      })
      .catch((error) => {
        if (error.name !== "AbortError" && requestId === treeRequestId) {
          console.error(error);
          loading = false;
        }
      });
  }

  function getTreeTime(applicableFilters, requestId, signal) {
    loading = true;
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/damprojects/AppScoresTreeTime?project_id=${idproject}&filter=${filterString}&cutoffpercentage=${percentage / 100}&source=${dataSource()}`,
      { signal },
    )
      .then((res) => res.json())
      .then((data) => {
        if (requestId !== treeRequestId) return;
        treeData = data;
        loading = false;
      })
      .catch((error) => {
        if (error.name !== "AbortError" && requestId === treeRequestId) {
          console.error(error);
          loading = false;
        }
      });
  }

  function handleDownload() {
    if (zoomableTreemap) zoomableTreemap.downloadSVG();
  }

  function findTreeNodeByPath(node, path) {
    let currentNode = node;
    const names = [...(path || [])].reverse();
    if (
      names.length &&
      normalizeAppName(names[0]) === normalizeAppName(currentNode?.name)
    ) {
      names.shift();
    }
    for (const name of names) {
      currentNode = (currentNode?.children || []).find(
        (child) => normalizeAppName(child.name) === normalizeAppName(name),
      );
      if (!currentNode) return null;
    }
    return currentNode;
  }

  function getTreeNodeValue(node) {
    if (!node) return 0;
    if (node.value !== undefined && node.value !== null) {
      return Number(node.value) || 0;
    }
    return (node.children || []).reduce(
      (sum, child) => sum + getTreeNodeValue(child),
      0,
    );
  }

  function formatPaxbotValue(value) {
    if (selectedKPIindex === 0) return formatTreemapTime(value);
    return `${Math.round(Number(value) || 0).toLocaleString("en-US")} interactions`;
  }

  function formatPaxbotCount(value) {
    const number = Number(value) || 0;
    if (Math.abs(number) >= 1_000_000)
      return `${(number / 1_000_000).toFixed(2)} M`;
    if (Math.abs(number) >= 1_000) return `${(number / 1_000).toFixed(1)} k`;
    return `${Math.round(number)}`;
  }

  function summarizeTreemapItems(items = []) {
    const total = items.reduce((sum, item) => sum + getTreeNodeValue(item), 0);
    return [...items]
      .filter((item) => normalizeAppName(item.name) !== "others")
      .sort((left, right) => getTreeNodeValue(right) - getTreeNodeValue(left))
      .map((item) => ({
        name: item.name,
        displayValue: formatPaxbotValue(getTreeNodeValue(item)),
        sharePercent: total
          ? Math.round((getTreeNodeValue(item) / total) * 1000) / 10
          : 0,
        appType: appTypesByName[normalizeAppName(item.name)] || undefined,
      }));
  }

  function getGlobalKpiContext() {
    const appData = selectedLevel > 0 ? currentWindowList : applicationlist;
    const selectedSummaryApp = appData.find(
      (app) => app.id == selectedApp || app?.windowtitle == selectedApp,
    );
    const summaryApps = Array.isArray(appSelectionKpiData)
      ? appSelectionKpiData
      : selectedSummaryApp
        ? [selectedSummaryApp]
        : appData;
    const summary = sumKpiRows(summaryApps);
    return {
      totalTime: formatTreemapTime(summary.time),
      mouseclicks: formatPaxbotCount(summary.mouseclicks),
      textTime: formatTreemapTime(summary.text_time),
      copyTime: formatTreemapTime(summary.copy_time),
    };
  }

  function getPaxbotContext() {
    const focusedNode = findTreeNodeByPath(treeData, currentApp) || treeData;
    const visibleChildren = focusedNode.children || [];
    return {
      page: "App Drilldown",
      projectId: idproject,
      metric: optionTabs[selectedKPIindex],
      source: dataSource(),
      level: selectedLevelOptions[selectedLevel],
      selection: currentApp.filter(Boolean).slice(-3),
      globalKpis: getGlobalKpiContext(),
      minimumSharePercent: percentage,
      activeFilterCount: getCurrentFilters().length,
      appTypeTotals: showAppTypes && selectedLevel === 0 ? appTypeTotals : null,
      visibleItemCount: visibleChildren.length,
      visibleItems: summarizeTreemapItems(visibleChildren),
    };
  }

  async function requestPaxbotAnswer(question, history, responseLanguage) {
    const response = await fetchWithSession("/api/damprojects/paxbot/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question,
        history: history.slice(-2),
        context: {
          ...getPaxbotContext(),
          responseLanguage,
        },
      }),
    });
    const responseText = await response.text();
    let result = {};
    try {
      result = responseText ? JSON.parse(responseText) : {};
    } catch (parseError) {
      throw new Error(
        `Paxbot endpoint returned ${response.status || "an invalid response"}`,
      );
    }
    if (!response.ok || result.status === "error") {
      throw new Error(result.message || "Paxbot request failed");
    }
    return result.answer;
  }

  onMount(() => {
    loadAppnameMapping();
  });
</script>

<Header
  paddingRight={false}
  section="Usage Analysis"
  area="Usage Analysis"
  breadcrumb="App Drilldown"
  tooltipText="The App Drilldown shows how time or interactions are distributed across applications and windows."
>
  <AppDrilldownSourceMenu bind:selected={selectedSourceIndex} />
  <Filter />
</Header>

<SectionWrapper
  fullscreen={fullscreen && !noDataForFilters}
  fitScreen={true}
  {loading}
  emptyState={noDataForFilters}
>
  <div slot="main" class="main_wapper">
    <PaxbotChat
      bind:open={paxbotOpen}
      heading="Pax AI"
      subheading="App Drilldown Assistant"
      starterQuestions={paxbotStarterQuestions}
      requestAnswer={requestPaxbotAnswer}
    />
    <div class="graph_top_right_toolbar">
      <Button
        kind={paxbotOpen ? "primary" : "secondary"}
        icon={BOT_WHITE_ICON}
        iconDescription="Pax AI"
        on:click={() => (paxbotOpen = !paxbotOpen)}
      />
    </div>
    <div class="canvas">
      <div class="ui_viewer_wrapper">
        {#key treeData}
          <ZoomableTreemap
            bind:this={zoomableTreemap}
            bind:currentApp
            {loading}
            formatfunction={selectedKPIindex
              ? yootils.commas
              : formatTreemapTime}
            {treeData}
            bind:level={selectedLevel}
            {partitionlabel}
            responsiveLabels
            pinOthersLast
            {showAppTypes}
            {appTypesByName}
            {appInfoByName}
            {windowInfoByName}
            bind:appTypeTotals
          />
        {/key}
      </div>
    </div>
    <div class="menu_overlay bottom">
      <div class="buttons_wrapper">
        <ContentSwitcher
          bind:selected={selectedKPIindex}
          options={optionTabs}
          fitContent={true}
          disabled={selectedSourceIndex === 1 ? [1] : []}
        />
      </div>

      <div class="buttons_wrapper">
        <!-- Temporarily disabled: download export needs to be fixed later. -->
        <!-- <Button kind="secondary" icon={DOWNLOAD_ICON} on:click={handleDownload} /> -->
        <Button
          kind="secondary"
          icon={fullscreen ? FULLSCREEN_OFF_ICON : FULLSCREEN_ICON}
          on:click={() => {
            fullscreen = !fullscreen;
          }}
        />
      </div>
    </div>
  </div>

  <div slot="emptyState" class="empty_state_text">
    <div class="empty_state_title">
      No data is available for this view with the selected filters.
    </div>
    <div class="empty_state_hint">
      Remove or adjust the filters to update the results.
    </div>
  </div>

  <div class="menu" slot="menu">
    <Accordion heading="App Info" open={true}>
      <div class="settings_wrapper">
        {#if showAppTypes}
          <div class="app_type_legend">
            {#each appTypeLegend as item}
              <div class="legend_row">
                <span
                  class="legend_swatch"
                  style="background-color: {item.color}"
                ></span>
                <span>{item.label}</span>
                <strong>{item.value}%</strong>
              </div>
            {/each}
          </div>
        {/if}

        <label class="settings_row" for="minimum-share">
          <span>Minimum share to show isolated</span>
          <select
            id="minimum-share"
            value={percentage}
            on:change={(event) => (percentage = Number(event.target.value))}
          >
            {#each minimumShareOptions as option}
              <option value={option}>{option}%</option>
            {/each}
          </select>
        </label>

        <div class="settings_row">
          <Toggle text="Show all App-Types" bind:active={showAppTypes} />
        </div>

        {#if showAppTypes}
          <div class="untyped_apps_row">
            <div class="untyped_apps_value">
              <span>Apps without Type</span>
              <strong>{untypedAppsPercentage}%</strong>
              <Tooltip>
                Share of the visible app value that has no app type assigned.
                Use the icon to map and categorize apps.
              </Tooltip>
            </div>
            <Button
              kind="secondary"
              icon={CATEGORY_ICON}
              size="small"
              on:click={openAppnameMapping}
            />
          </div>
        {/if}
      </div>
    </Accordion>

    <Accordion heading="App Selection" open={true}>
      {#key selectedLevel}
        <AppSelection
          appData={selectedLevel > 0 ? currentWindowList : applicationlist}
          bind:currentApp={selectedApp}
          bind:selectedLevel
          windowSelectionEnabled={false}
          showKpiSummary
          readableDuration
          kpiSummaryData={appSelectionKpiData}
          loading={loading ||
            (selectedLevel > 0
              ? windowPartitionsLoading
              : applicationKpisLoading)}
          W
        />
      {/key}
    </Accordion>
  </div>
</SectionWrapper>

<style>
  /* .upload_wrapper {
    padding-top: 1rem;
    margin-top: 1rem;
    border-top: 1px solid #d9d9d9;
  }

  .toggle_wrapper {
    display: flex;
    flex-direction: column;
  } */

  .main_wapper {
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .graph_top_right_toolbar {
    align-items: center;
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    position: absolute;
    right: 0.25rem;
    top: 0.25rem;
    z-index: 31;
  }

  .main_wapper :global(.paxbot_chat_window) {
    bottom: 5.85rem !important;
    position: absolute !important;
    right: 1rem !important;
    z-index: 50 !important;
  }

  .main_wapper :global(.paxbot_chat_mascot) {
    bottom: -0.65rem !important;
    position: absolute !important;
    right: 1.55rem !important;
    z-index: 51 !important;
  }

  .menu_overlay {
    position: absolute;
    width: 100%;
    z-index: 1; /* Stellt sicher, dass das Overlay über dem Canvas liegt */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bottom {
    bottom: 0;
  }

  .canvas {
    height: calc(100% - 110px);
    width: 100%;
    z-index: 0; /* Platziert das Canvas hinter den Overlays */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .buttons_wrapper {
    display: flex;
    gap: 0.5rem;
    user-select: none;
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: calc(100vh - 6rem);
    overflow-y: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .ui_viewer_wrapper {
    height: 100%;
    width: 100%;
  }

  .empty_state_title,
  .empty_state_hint {
    font-size: 1rem;
  }

  .empty_state_title {
    color: var(--pax-black);
  }

  .empty_state_hint {
    color: var(--pax-grey);
    margin-top: 0.5rem;
  }

  .settings_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
  }

  .settings_row,
  .legend_row {
    min-height: 2.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.6rem 0.75rem;
    border-radius: 0.5rem;
    background-color: var(--pax-smoke);
    color: var(--pax-black);
    box-sizing: border-box;
  }

  .settings_row span,
  .legend_row span,
  .legend_row strong,
  .untyped_apps_value span,
  .untyped_apps_value strong {
    font-size: inherit;
  }

  .settings_row select {
    height: 2rem;
    min-width: 4.25rem;
    border: 1px solid #d9d9d9;
    border-radius: 0.5rem;
    background-color: var(--pax-white);
    color: var(--pax-black);
    font: inherit;
    padding: 0 0.5rem;
    outline: none;
  }

  .settings_row select:focus {
    border-color: var(--pax-black);
  }

  .settings_row :global(.toggle_wrapper) {
    width: 100%;
    height: auto;
  }

  .app_type_legend {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .legend_row {
    display: grid;
    grid-template-columns: 1.5rem minmax(0, 1fr) auto;
  }

  .legend_swatch {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 0.35rem;
    border: 1px solid var(--pax-black);
  }

  .untyped_apps_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid #d9d9d9;
  }

  .untyped_apps_value {
    display: flex;
    gap: 0.35rem;
    align-items: center;
    min-width: 0;
  }
</style>
